import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import moment from 'moment'
import { contains } from 'ramda'
import {
  Button,
  Colors,
  Modal, Select,
} from 'advenio-components'

import RegisterActivity from './RegisterActivity'
import Meal from './Meal'
import Drink from './Drink'
import Eat from './Eat'
import Incident from './Incident'
import Report from './Report'
import AddPhoto from './AddPhoto'
import Diaper from './Diaper'
import Nap from './Nap'
import ConfirmMeal from './ConfirmMeal'
import KidsToSleep from './KidsToSleep'
import ExtraCharge from './ExtraCharge'

const Views = {
  home: { title: 'Registrar Actividad', component: RegisterActivity },
  Food: { title: 'Alimentacion', component: Meal },
  drink: { title: '¿Cuánto tomó?', component: Drink },
  eat: { title: '¿Cuánto Comió?', component: Eat },
  confirm: { title: 'Confirmar', component: ConfirmMeal },
  Incident: { title: 'Agregar Incidente', component: Incident },
  'Special Report': { title: 'Reporte Especial', component: Report },
  Photo: { title: 'Agregar Foto', component: AddPhoto },
  Diaper: { title: 'Checar pañal', component: Diaper },
  Nap: { title: 'Siesta', component: Nap },
  kidsToSleep: { title: 'Seleccionar Niños', component: KidsToSleep },
  extraCharge: { title: 'Cargos Extra', component: ExtraCharge },
}

const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex: 0 auto;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 80px;
  border-bottom: solid 1px ${Colors.gray300};
`
const NameHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 8px;
`
const Close = styled.div`
  position: absolute;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 50px;
`
const Save = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 150px;

  @media (max-width: 763px) {
    width: 100px;
  }
`
const Profile = styled.div`
  width: 18px;
  height: 18px;
  margin-right: 4px;
  border-radius: 50%;
  border: 1px solid ${Colors.gray300};
  background-image: ${({ profile }) => profile ? `url(${profile})` : 'url(/assets/BabyAvatar.svg)'};
  background-size: cover;
  background-position: center;
`
const Content = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 500px;

  @media (max-width: 763px) {
    height: 100%;
    overflow: scroll;
    justify-content: flex-start;
    min-height: auto;
  }
`
const NameSpan = styled.span`
  color: ${Colors.gray500};
`
const Img = styled.img`
  padding: 16px;
  cursor: pointer;
`
const FinishActivity = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  width: 100%;
  background-color: ${Colors.yellow500};
`
const ProgressActivity = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const ProgressActivityTitle = styled.span`
  margin-left: 8px;
  font-size: 12px;
  color: ${Colors.yellowText};
`
const ProgressActivityName = styled.span`
  margin-left: 8px;
`
const ConfirmModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 600px;

  @media (max-width: 763px) {
    height: 200px;
    margin-left: 25px;
    margin-right: 20px;
  }
`
const ConfirmButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`

class Activity extends Component {
  constructor(props) {
    super(props)
    const home = props.isIncidentActivity ? 'Incident' : 'home'

    this.state = {
      currentView: home,
      info: [],
      width: 0,
      previousView: '',
      ActivityInProgress: false,
      ActivityCategory: '',
      ActivityId: '',
      ActivityName: '',
      category: '',
      isConfirmed: false,
    }
  }

  // TODO: Refactor logic for this entire method
  componentWillMount() {
    const {
      categories,
      child: { latest_activities },
      isIncidentActivity,
    } = this.props
    let categoryid = ''
    let id = ''
    let cat = []
    let type = []
    let isValid = false
    let date = null

    if (latest_activities) {
      Object.keys(latest_activities)
        .filter(activityDate => moment(activityDate, 'YYYY-MM-DD', true).isValid())
        .map((activityDate) => {
          isValid = true
          date = activityDate

          return activityDate
        })

      for (let i = 0; i < latest_activities.length; i += 1) {
        let ActivityName = null

        if (latest_activities[i].finished_at !== null) {
          continue
        }

        categoryid = latest_activities[i].category_id
        id = latest_activities[i].id
        cat = categories.filter(c => c.id == categoryid)
        if (cat[0].name == 'Food') {
          type = cat[0].types.filter(t => t.id == latest_activities[i].type_id)
        }

        if (type != '') {
          ActivityName = type[0].translations.es
        } else {
          ActivityName = cat[0].translations.es
        }

        this.setState({
          ActivityInProgress: true,
          ActivityCategory: categoryid,
          ActivityId: id,
          ActivityName,
        })
      }

      if (isValid) {
        Object.keys(latest_activities).map((date) => {
          if (!moment(date, 'YYYY-MM-DD', true).isValid() || !latest_activities[date][0].description) {
            return null
          }

          let key = 0

          for (key;latest_activities[date][key].description.includes('foto')||latest_activities[date][key].description.includes('Reporte');){
            key+=1;
          }

          const foundActivity = latest_activities[date][key]
          const foundCategory = categories
            .find(category => Number(category.id) === Number(foundActivity.category_id))

          if (foundCategory && foundCategory.id===1 ||foundCategory.id===2) {
            const foundType = foundCategory.types
              .find(categoryType => Number(categoryType.id) === Number(foundActivity.type_id))

            if (foundActivity.description.includes('Inició')) {
              this.setState({
                ActivityInProgress: true,
                ActivityCategory: foundCategory,
                ActivityId: foundActivity.activity_id,
                ActivityName: foundType.translations.es,
              })
            }

            if (foundActivity.description.includes('Empezó')) {
              this.setState({
                ActivityInProgress: true,
                ActivityCategory: foundCategory,
                ActivityId: foundActivity.activity_id,
                ActivityName: foundType.translations.es,
              })
            }
          }
        })
      }
    }

    if (categories && isIncidentActivity) {
      const incidentCategory = categories.find(category => category.name === 'Incident')
      this.setState({ category: incidentCategory.id })
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onClick = () => this.props.postActivity(this.props.child.checkin.id, this.state.info)

  setExtraData = info => this.setState({ info })

  goToView = (view, previousView, category) =>
    this.setState({ currentView: view, previousView, category })

  updateWindowDimensions = () => this.setState({ width: window.innerWidth })

  closeModal = () => this.props.closeModal()

  finishActivity = () => {
    const { ActivityId } = this.state

    if (this.isActivityName(['Siesta', 'Empezó su siesta'])) {
      if (ActivityId) {
        this.props.postFinishActivity(ActivityId, '')
      }

      return null
    }

    let nextCategory = ''

    this.props.categories.forEach((category) => {
      const categoryTypes = category.types

      if (category.name === 'Food' && categoryTypes.length > 0) {
        categoryTypes.forEach((type) => {
          if (this.isActivityName(type.translations.es)) {
            nextCategory = type.id
          }
        })
      }
    })

    return this.goToView('drink', '', nextCategory)
  }

  cancel = () => this.setState({ isConfirmed: false })

  confirm = () => this.setState({ isConfirmed: true })

  goBack = () => {
    if (!this.isCurrentView(['eat', 'extraCharge', 'confirm', 'drink'])) {
      return this.goToView('home', '', '')
    }

    return this.backMeal()
  }

  backMeal = () => {
    let nextCategory = ''
    let view = 'home'

    this.props.categories.forEach((category) => {
      if (category.name === 'Food') {
        nextCategory = category.id
      }
    })

    switch (this.state.currentView) {
      case 'confirm':
        view = 'extraCharge'
        break
      case 'extraCharge':
        view = 'eat'
        break
      case 'eat':
        view = 'drink'
        break
      case 'drink':
        view = 'home'
        break
      default:
        break
    }

    this.goToView(view, '', nextCategory)

    if (this.isCurrentView('drink')) {
      this.cancel()
    }
  }

  isCurrentView = views => contains(this.state.currentView, views)

  isActivityName = values => contains(this.state.ActivityName, values)

  render() {
    const { ActivityId, ActivityInProgress, ActivityName, category, currentView,
      info, isConfirmed, previousView, width } = this.state
    const { categories, child, children, loading, postActivity,
      postFinishActivity, activeClassroom } = this.props
    const CurrentView = Views[currentView]

    return (
      <ModalContainer>
        <HeaderContainer>
          <Close>
            {!this.isCurrentView('home') && !this.isCurrentView('Incident') ?
              <Img src="/assets/back.svg" onClick={this.goBack} /> :
              <Img src="/assets/Close.svg" onClick={this.closeModal} />
            }
          </Close>
          <span>{CurrentView.title}</span>
          <NameHeader>
            <Profile profile={child.profile_image} />
            <NameSpan>{child.first_name} {child.last_name_paternal}</NameSpan>
          </NameHeader>
          <Save>
            {this.isCurrentView(['Incident', 'Special Report', 'Photo', 'Food']) ?
              <Button
                small
                style={width < 763 ? { width: '80px', height: '50px', fontSize: '13px' } : {}}
                primary={Object.keys(info).length > 0}
                onClick={this.onClick}
                disabled={Object.keys(info).length <= 0 || ('description' in info && info.description === '')}
                loading={loading}
              >
                {this.isCurrentView('Food') ? 'Iniciar' : 'Confirmar'}
              </Button> :
              ''
            }
            {this.isCurrentView('Diaper') ?
              <Button
                small
                style={width < 763 ? { width: '80px', height: '50px', fontSize: '13px' } : {}}
                primary={!!(info.contents_id && info.type_id)}
                onClick={this.onClick}
                disabled={!(info.contents_id && info.type_id)}
                loading={loading}
              >
                Confirmar
              </Button> :
              ''
            }
          </Save>
        </HeaderContainer>
        <Content pending={ActivityInProgress}>
          {ActivityInProgress && this.isCurrentView('home') ?
            <FinishActivity>
              <ProgressActivity>
                <img style={{ marginLeft: '10px' }} src="/assets/ProgressActivity.svg" alt="Actividad en progreso" />
                <ProgressActivityTitle>Actividad en progreso:</ProgressActivityTitle>
                <ProgressActivityName>{ActivityName}</ProgressActivityName>
              </ProgressActivity>
              <Button
                small
                danger
                onClick={this.confirm}
              >
                Terminar
              </Button>
              <Modal
                isOpened={isConfirmed}
                onClose={this.cancel}
              >
                <ConfirmModal>
                  <span>¿Seguro que quieres terminar esta actividad?</span>
                  <ConfirmButtons>
                    <Button large primary onClick={this.finishActivity}>Si</Button>
                    <Button
                      large
                      danger
                      onClick={this.cancel}
                    >
                      No
                    </Button>
                  </ConfirmButtons>
                </ConfirmModal>
              </Modal>
            </FinishActivity> :
            ''
          }
          <CurrentView.component
            goToView={this.goToView}
            child={child}
            children={children}
            setExtraData={this.setExtraData}
            info={info}
            closeModal={this.closeModal}
            view={currentView}
            previousView={previousView}
            categories={categories}
            postActivity={postActivity}
            postFinishActivity={postFinishActivity}
            activityId={ActivityId}
            category={category}
            activityAlreadyInProgress={ActivityInProgress}
            activeClassroom={activeClassroom}
          />
        </Content>
      </ModalContainer>
    )
  }
}

Activity.propTypes = {
  closeModal: PropTypes.func.isRequired,
}

export default Activity



// WEBPACK FOOTER //
// ./src/Components/Activity/index.jsx